export default function ExtraInfoFormContainer(props: {children?: any}): JSX.Element {
    return <>
        <div className="flex flex-col md:grid md:px-10 gap-4 md:grid-cols-12 mt-10">
            {props.children}
        </div>
    </>
}